import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import {
  ApiResponse,
  WidgetData
} from 'src/app/model';
import { WidgetsServiceService } from 'src/app/modules/home/widgets-collection/widgets-service.service';
import { ServicecallService } from 'src/app/services/servicecall.service';

@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.css']
})
export class HealthComponent implements OnInit, OnDestroy {

  @Input() entityDetails: any;
  @Input() widgetData: WidgetData;
  @Input() entityId: string;

  linearGaugeData: { status: string };

  private _activeEntityDetailsSubscription: Subscription;
  private _values: string[] = [];
  private _destroy$ = new Subject<void>();

  constructor(private _datePipe: DatePipe, private _widgetService: WidgetsServiceService,
    private _service: ServicecallService) { }

  ngOnDestroy(): void {
    this._activeEntityDetailsSubscription?.unsubscribe();
    this._destroy$.next();
    this._destroy$.complete();
  }

  ngOnInit(): void {
    this._values = this._service.getConfigurationBasedOnCategory(this.entityDetails)?.healthWidgetData ? this._service.getConfigurationBasedOnCategory(this.entityDetails)?.healthWidgetData : [];
    this._activeEntityDetails();
  }

  /**
   * Gets Active entity details
   */
  private _activeEntityDetails() {
    const endDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
    const requestData = {
      siteId: this._service.getSiteId(),
      from: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityDetails?._id,
      count: 1
    };
    this._activeEntityDetailsSubscription = this._widgetService.activeEntityDetails(requestData, 1).subscribe({
      next: (result: ApiResponse) => {
        if (result?.status) {
          if (result?.response?.data?.length) {
            this.linearGaugeData = {
              status: this._checkAttributes(this._values, result?.response?.data?.[0]?.attributes) ? '90' : '10'
            };
          } else {
            this.linearGaugeData = {
              status: '10'
            };
          }
        }
      }, error: (error) => {
        if (error) {
          this._service.toasterService({ type: 'error', msg: error });
        }
      }
    });
    this._refreshApi();
  }

  /**
   * Checks attributes
   * @param attributeNames 
   * @param attributes 
   * @returns true if attributes are online
   */
  private _checkAttributes(attributeNames: string[], attributes: { attributeName: string; attributeValue: string }[]): boolean {
    const attributeMap = new Map(attributes?.map(attribute => [attribute?.attributeName, attribute?.attributeValue]));
    return attributeNames?.every(name => attributeMap?.get(name) === '1.0');
  }

  /**
   * Refreshs api
   */
  private _refreshApi() {
    if (+this.widgetData.refreshRate) {
      this._clearTimer();
      interval(+this.widgetData.refreshRate).pipe(
        takeUntil(this._destroy$)
      ).subscribe(() => {
        this._activeEntityDetails();
      });
    }
  }

  /**
   * Clears timer
   */
  private _clearTimer() {
    this._destroy$.next();
  }

}
